import {NotificationDialogComponent} from '../notification-dialog/notification-dialog.component';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChildren} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material';
import {EditionLayer} from '../../models/edition-layer';
import {AddimageService} from '../../services/data/addimage.service';
import {LoginService} from '../../services/login/login.service';
import {InsertFeatureService} from '../../services/data/insert-feature.service';
import {Router} from '@angular/router';
import * as ol from 'openlayers';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ConfigService} from '../../services/utils/config.service';
import {environment} from '../../../environments/environment';
import {SignatureComponent} from '../signature/signature.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ConfigParamsService } from '../../services/configParameters/config-params.service';
import {DomSanitizer} from '@angular/platform-browser';

declare var moment;
@Component({
  selector: 'app-feature-edition-panel',
  templateUrl: './feature-edition-panel.component.html',
  styleUrls: ['./feature-edition-panel.component.css']
})
export class FeatureEditionPanelComponent implements OnInit, OnChanges {

  @ViewChildren(SignatureComponent) signatureComponents: QueryList<SignatureComponent>;

  @Output() mostrarMapa = new EventEmitter<any>();
  @Output() modificarPosicio = new EventEmitter<any>();
  @Input() editionFeature: any;
  editionFormControl: FormGroup;
  public formModel: object = null;
  public feature: object = null;
  public layer: EditionLayer = null;
  public olFeature: any = null;
  public image_fields = [];
  public signature_fields = [];
  private signaturesToDelete = [];
  public has_imatge = false;
  private error_message = {};
  public selectedValue = {};
  public isInsertTransactionMode = this.feature !== null && typeof (this.feature['INSERT']) !== 'undefined';
  public isUpdateTransactionMode = this.feature !== null && typeof (this.feature['UPDATE']) !== 'undefined';
  private loadingWFS = false;
  public isPointLayer = false;
  protected signedAndValidated: {
    nom: string;
    camp: string;
    link: string;
    value: boolean;
  };
  protected allSignaturesPresent = false;
  private buffered_signatures: any = {};
  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    public addImageService: AddimageService,
    public insertFeatureService: InsertFeatureService,
    private router: Router,
    public loginService: LoginService,
    private configService: ConfigService,
    private matSnackBar: MatSnackBar,
    private translateService: TranslateService,
    protected configParamsService: ConfigParamsService,
    protected sanitizer: DomSanitizer,
  ) {
    if (!loginService.checkLogin() && this.configParamsService.isPrivateApp()) {
      this.router.navigate(['/privat']);
    }
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    console.debug('>>> FeatureEditionPanelComponent: ngOnChanges');
    try {
      if (typeof (changes.editionFeature) !== 'undefined' && typeof (changes.editionFeature.currentValue) !== 'undefined') {
        this.layer = changes.editionFeature.currentValue['layer'];
        this.isPointLayer = this.layer.geometria_tipus.toLowerCase() === "point";
        this.olFeature = changes.editionFeature.currentValue['feature'];
        this.feature = this.processFeatureProperties(this.olFeature.getProperties());
        this.isInsertTransactionMode = this.feature !== null && this.feature['transaction'] === 'INSERT';
        this.isUpdateTransactionMode = this.feature !== null  && this.feature['transaction'] === 'UPDATE';;
      }
    }
    catch (e) { console.warn('Ups, hi ha hagut algun problema al ngOnChanges del feature-edition-panel.component.ts', e); }
  }

  onchangesFoto($event) {
    if ($event.target) {
      let files = $event.target.files[0];

      let newFileName = files.name;
      this.loadingWFS = true;
      this.addImageService.uploadFile(files, newFileName, this.layer.carpeta_imatges, this.layer.base_url_imatges).then(data => {
        if(this.image_fields.length>1){
          for(let index = 0; index < this.image_fields.length; index++){
            let image_field = this.image_fields[index];
            if(image_field.path_img === null){
              let is_path = data['is_path'];
              let image = data['img_file'];
              image_field.input_value = image;
              if (is_path === 'true') {
                this.has_imatge = true;
                image_field.path_img = this.layer.base_url_imatges + '/' + this.layer.carpeta_imatges + '/' + image;
              }
              else {
                this.has_imatge = true;
                image_field.path_img = image;
              }
              break;
            }
          }
        }else if(this.image_fields.length===1){
          let is_path = data['is_path'];
          let image = data['img_file'];
          this.image_fields[0].input_value = image;
          if (is_path === 'true') {
            this.has_imatge = true;
            this.image_fields[0].path_img = this.layer.base_url_imatges + '/' + this.layer.carpeta_imatges + '/' + image;
          }
          else {
            this.has_imatge = true;
            this.image_fields[0].path_img = image;
          }

        }

        this.loadingWFS = false;
      });
    }
  }

  public deleteFoto(image){
    image.input_value = null;
    image.path_img = null;
    let is_there_any_image = false;
    for(let index = 0; index < this.image_fields.length; index++){
      let image_field = this.image_fields[index];
      if(image_field.path_img !== null){
        is_there_any_image = true;
        break;
      }
    }
    this.has_imatge = is_there_any_image;
  }

  protected removeSignature(fieldName: string) {
    const fieldObj = Object.values(this.feature).find(field => field.camp === fieldName);
    if (fieldObj) {
      fieldObj.valor = null;
    }
    const signatureFormItem = this.signature_fields.find(s => s.placeholder === fieldName);
    if (signatureFormItem) {
      this.signaturesToDelete.push(signatureFormItem.originalPath);
      signatureFormItem.requestUrl = null;
    }
    this.signedAndValidated.value = false;
    this.allSignaturesPresent = false;
  }

  private deleteSignatureImage(signaturePath: string) {
    this.addImageService.deleteSignature(signaturePath)
        .subscribe(
            res => console.log(`Deleted ${res}`),
                e => console.error(e));
  }

  private processFeatureProperties(featureProperties): object {
    const properties = {};
    let countPropertiesFromFeature = 0;
    for (let index = 0; index < this.layer.atributs.length; index++) {
      const atribut = this.layer.atributs[index];
      if (typeof (featureProperties[atribut.camp]) !== 'undefined') {
        countPropertiesFromFeature++;
        properties[index] = atribut;
        properties[index].valor = this.formatValue(atribut.camp, atribut.amagat, atribut.format, featureProperties[atribut.camp], atribut.valors, atribut.nom, atribut.obligatori, atribut.link);
        if (properties[index].valor.toString().indexOf("http") >= 0) {
          properties[index].enllac = properties[index].valor;
        }
      } else {
        properties[index] = atribut;
        properties[index].valor = this.formatValue(atribut.camp, atribut.amagat, atribut.format, '', atribut.valors, atribut.nom, atribut.obligatori, atribut.link);
      }
    }

    this.allSignaturesPresent = this.signature_fields.every(s => s.requestUrl && s.requestUrl.length > 0);

    /*no en te cap, el feature es buit*/
    if (countPropertiesFromFeature > 0) {
      properties['transaction'] = 'UPDATE';
    }
    else {
      properties['transaction'] = 'INSERT';
    }

    return properties;
  }

  public formatValue(namefield, hidden, format, value, listValues, nom, obligatori, link = ''): any {
    let value_ = value;
    if (value_ === null) {
      console.debug('Camp ' + namefield + ' (format ' + format + ') és null');
      value_ = '';
    }
    if (format === 'D' && !hidden) {
      let str_date = moment(value_.replace('Z', 'T23:00:00Z')).format('YYYY-MM-DD');
      return str_date;
    } else if (format === 'D' && hidden) {
      let date_ = new Date();
      return date_.toISOString().split('T')[0];
    }
    if (format === 'U' && hidden) {
      let username = 'ANONIM';
      if(this.configParamsService.isPrivateApp()){
        username = this.loginService.getUsername().toLowerCase();
      }
      return username;
    }
    if (format === 'F') {

      if (value_ && value_ !== '') {
        this.image_fields.push({
          field: namefield,
          path_img: value_,
          amagat: hidden,
          placeholder: nom,
          input_value: value_,
          required: obligatori
        });
        this.has_imatge = true;
      } else {
        this.image_fields.push({
          field: namefield,
          path_img: null,
          amagat: hidden,
          placeholder: nom,
          input_value: null,
          required: obligatori
        });
        this.has_imatge = this.has_imatge || false;
        return false;
      }

      return value_;
    }

    if (format === 'S') {
      const signature = {
        field: namefield,
        requestUrl: value
            ? `${this.configService.getBaseApiUrl}${environment.RESOURCES.SIGNATURES}?encoded=${encodeURIComponent(value)}`
            : undefined,
        blobImg: undefined,
        originalPath: value,
        amagat: hidden,
        placeholder: nom,
        input_value: value,
        required: obligatori
      };

      this.loadSignatureImage(signature);

      this.signature_fields.push(signature);
    }

    if (format === 'L') {
      let value_1 = listValues.filter(valor => (valor['text'] === value) || valor['id'] === value);
      if (value_1.length > 0) {
        this.selectedValue[namefield] = value_1[0].id;
        return this.selectedValue;
      }
    }
    if (format === 'B' ) {
      if (value !== null && value.toString().toUpperCase() === 'SI') {
        return true;
      }
      return false;
    }
    if (format === 'V') {
      this.signedAndValidated = {
        nom: nom,
        camp: namefield,
        link: link,
        value: value === true
      };
    }
    return value_;
  }

  private loadSignatureImage(signature: {
    field: any;
    requestUrl: string;
    blobImg: any;
    originalPath: any;
    amagat: any;
    placeholder: any;
    input_value: any;
    required: any
  }) {
    if (signature.requestUrl) {
      this.http.get(signature.requestUrl, {responseType: 'blob'}).toPromise().then(image => {
        signature.blobImg = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(image));
      }).catch(error => {
        signature.blobImg = undefined;
        console.error('No s\'ha pogut carregar la imatge', error);
      });
    }
  }

  public openNotificationDialog(status, message, options): void {
    try {
      let width = window.innerWidth * 0.80;
      if (width > 385) {
        width = 449;
      }
      let dialogRef = this.dialog.open(NotificationDialogComponent, {
        width: width + 'px',
        data: {
          header: status,
          status: status,
          message: message
        }
      });

      dialogRef.afterClosed().subscribe(() => {
        if (options.refresh) {
          window.location.reload();
        }
        this.cancelEdition();
        console.log('The dialog was closed');
      });

    } catch (ex) {
      console.error('Error trying to open the dialog', ex);
    }

  }

  public cancelEdition() {
    this.mostrarMapa.emit({
      coord_x: this.olFeature.getGeometry().getCoordinates()[0],
      coord_y: this.olFeature.getGeometry().getCoordinates()[1]
    });
  }

  public isFieldVisible(field): boolean {
    if (field.amagat) {
      return false;
    }
    if (field.privat && !this.configParamsService.isPrivateApp()) {
      return this.isInsertTransactionMode;
    }
    return true;
  }

  private async updateSignaturePaths() {
      const promises = this.signatureComponents.map(async c => {
          const res = await c.saveSignature().toPromise().catch(e => this.openNotificationDialog('error', 'edition.error_message', { refresh: false }));
          const fieldObj = Object.values(this.feature).find(field => field.camp === c.signatureElementId);
          if (fieldObj && res.content || !res) {
              fieldObj.valor = res.content || null;
              this.buffered_signatures[c.signatureElementId] = res.content || null;
              const signature = this.signature_fields.find(s => s.field === c.signatureElementId);
              signature.requestUrl = res.content
                  ? `${this.configService.getBaseApiUrl}${environment.RESOURCES.SIGNATURES}?encoded=${encodeURIComponent(res.content)}`
                  : null;
              this.loadSignatureImage(signature);
          }
      });

      await Promise.all(promises);
      this.allSignaturesPresent = this.signature_fields.every(s => s.requestUrl && s.requestUrl.length > 0);
  }

  public initPanel(event: object) {
    this.feature = event['feature'];
    this.layer = event['layer'];
  }

  public async sendFeatureTransaction() {
    let errorVariableReceived = false;
    if (this.loadingWFS) {
      return;
    }
    const transaction_wfs = new ol.format.WFS({ 'featureNS': this.layer.namespace, 'featureType': this.layer.capes });
    await this.updateSignaturePaths();

    let featureProperties = {};

    if (this.signature_fields.length > 0) {
      if (this.signedAndValidated && ((this.allSignaturesPresent && !this.signedAndValidated.value) || (!this.allSignaturesPresent && this.signedAndValidated.value))) {
        this.translateService.get('signature.validation.error').subscribe(msg => {
          this.matSnackBar.open(msg, 'X', {
            duration: 5000,
            panelClass: 'error-snackbar'
          });
        });
        return;
      }
      featureProperties = {...this.buffered_signatures};
      if (this.signedAndValidated) {
        featureProperties[this.signedAndValidated.camp] = this.signedAndValidated.value;
      }
    }

    const getProps = (editionAttrIndex) => {
      const editionAttr = this.feature[editionAttrIndex];
      try {
        if (editionAttr['removeIfEmpty'] && !document.getElementById(editionAttr['camp'])['value']) {
          return;
        }

        if (editionAttr['camp'] && editionAttr['format'] !== 'L' &&  editionAttr['format'] !== 'B') {
          let value_ = document.getElementById(editionAttr['camp'])['value'];
          if (value_ !== null && value_.length > 0) {
            featureProperties[editionAttr['camp']] = value_;
          } else {
            if (editionAttr['obligatori']) {
              errorVariableReceived = true;
            } else {
              featureProperties[editionAttr['camp']] = this.getDefaultValue(editionAttr);
            }
          }
        } else if (editionAttr['format'] === 'L') {
          let selval = this.selectedValue[editionAttr['camp']];
          if (!errorVariableReceived) {
            if ((selval === undefined) && (editionAttr['obligatori']))	{
              errorVariableReceived = true;
            }
          }
          const valor = editionAttr['valors'].filter(v => v['id'] === selval);
          featureProperties[editionAttr['camp']] = valor[0]['id'];
        } else if (editionAttr['format'] === 'B') {
          let value_ = document.getElementById(editionAttr['camp'])['value'];
          if (value_ === 'true' ) {
            value_ = 'Si';
          } else {
            value_ = 'No';
          }
          featureProperties[editionAttr['camp']] = value_;
        }


      }
      catch (e) { }
    };

    for (const editionAttrIndex in this.feature) {
      getProps(editionAttrIndex);
    }

    let body = "";
    if (!errorVariableReceived) {
      const newFeature = new ol.Feature({ geometry: this.olFeature.getGeometry() });
      newFeature.setProperties(featureProperties);
      newFeature.setId(this.olFeature.getId());
      let node;
      const options = {
        'featureNS': this.layer.namespace,
        'featureType': this.layer.capes,
        'featurePrefix': this.layer.prefix,
        'nativeElements': []
      };
      if (this.feature['transaction'] === 'INSERT') {
        node = transaction_wfs.writeTransaction([newFeature], null, null, options);
      } else if (this.feature['transaction'] === 'UPDATE') {
        node = transaction_wfs.writeTransaction(null, [newFeature], null, options);
      }
      let stringXmlDoc = new XMLSerializer().serializeToString(node);
      stringXmlDoc = stringXmlDoc.replace('ISO-8859-15', 'UTF-8');
      //Es duran a terme els 3 replaces ja que altrament es podria veure afectat el funcionament. Més endavant seria interessant poder fer servir "replaceAll" però faria falta actualitzar el lib del tsconfig.json
      stringXmlDoc = stringXmlDoc.replace('geometry', '' + this.layer.geometria_camp);
      stringXmlDoc = stringXmlDoc.replace('<geometry', '<' + this.layer.geometria_camp);
      stringXmlDoc = stringXmlDoc.replace('</geometry', '</' + this.layer.geometria_camp);
      body = stringXmlDoc;
    }

    const headers = new HttpHeaders({
      'Content-Type':  'text/xml;charset=utf-8',
      'Authorization': 'Basic ' + this.loginService.getGeoserverAuth()
    });

    const handleSuccessMessage = (success) => {
      const xmlMessageString = success;
      console.log(xmlMessageString);
      if ((success.indexOf('wfs:TransactionSummary') < 0) || (errorVariableReceived)) {
        this.openNotificationDialog('error', 'edition.error_message', { refresh: false });
      } else {
        this.openNotificationDialog('success', 'edition.success_message', { refresh: false });
        this.signaturesToDelete.forEach(s => {
          this.deleteSignatureImage(s);
        });
      }
    };
    console.log(body);
    this.http.post(this.layer.url, body, {
      headers: headers,
      responseType: 'text'
    }).toPromise()
      .then(handleSuccessMessage).catch((error)=>{
        console.error('An error occurred', error); // for demo purposes only
        this.openNotificationDialog('error', 'edition.error_message', { refresh: false });
    });
  }

  private getDefaultValue(editionAttr) {
    switch (editionAttr['format']) {
      case 'D':
        return'1900-01-01';
      case 'N':
        return '-1';
      default:
        return '';
    }
  }

  public sendFeatureDeleteTransaction() {
    let transaction_wfs = new ol.format.WFS({ 'featureNS': this.layer.namespace, 'featureType': this.layer.capes });
    let newFeature = new ol.Feature({ geometry: this.olFeature.getGeometry() });
    newFeature.setId(this.olFeature.getId());
    const options_ = { 'featureNS': this.layer.namespace, 'featureType': this.layer.capes, 'featurePrefix': this.layer.prefix, 'nativeElements': [] };
    const node = transaction_wfs.writeTransaction(null, null, [newFeature], options_);
    let stringXmlDoc = new XMLSerializer().serializeToString(node);
    stringXmlDoc = stringXmlDoc.replace('ISO-8859-15', 'UTF-8');
    stringXmlDoc = stringXmlDoc.replace('geometry', '' + this.layer.geometria_camp);
    stringXmlDoc = stringXmlDoc.replace('<geometry', '<' + this.layer.geometria_camp);
    stringXmlDoc = stringXmlDoc.replace('</geometry', '</' + this.layer.geometria_camp);
    const body = stringXmlDoc;

    const headers = new HttpHeaders({
      'Content-Type':  'text/xml;charset=utf-8',
      'Authorization': 'Basic '+this.loginService.getGeoserverAuth()
    });

    let handleSuccessMessage = (success) => {
      const xmlMessageString = success;
      console.log(xmlMessageString);
      if (success.indexOf('wfs:TransactionSummary') < 0) {
        this.openNotificationDialog('error', 'edition.error_message', { refresh: false });
      }
      else {
        this.openNotificationDialog('success', 'edition.success_message', { refresh: false });
        this.signature_fields.forEach(s => this.deleteSignatureImage(s.originalPath));
      }
    };
    this.http.post(this.layer.url, body, {
      headers: headers,
      responseType: 'text'
    }).toPromise()
      .then(handleSuccessMessage).catch((error)=>{
        console.error('An error occurred', error); // for demo purposes only
        this.openNotificationDialog('error', 'edition.error_message', { refresh: false });
      });
  }

  public validateField(field): object {
    let classesOBJ = {};
    try {
      if (field.longitudMax && field.longitudMax > 0) {
        let input_value = document.getElementById(field.camp)['value'];
        classesOBJ['hiddenVisibility'] = input_value.length <= field.longitudMax && (input_value.length > 0 || !field.obligatori);
        classesOBJ['error_too_long'] = input_value.length > field.longitudMax;
        classesOBJ['error_empty'] = input_value.length === 0 && field.obligatori;
        if (classesOBJ['error_empty']) {
          this.error_message[field.camp] = 'error_empty';
        }
        else if (classesOBJ['error_too_long']) {
          this.error_message[field.camp] = 'error_too_long';
        }
        else {
          this.error_message[field.camp] = '';
        }
      }
    }
    catch (e) {
      classesOBJ['hiddenVisibility'] = true;
      classesOBJ['error_too_long'] = false;
      classesOBJ['error_empty'] = false;
      this.error_message[field.camp] = '';
    }
    return classesOBJ;
  }
  private getMessageValidation(field_camp): string {
    return this.error_message[field_camp];
  }



  public enableModificarPosicioFeature() {

    let featureProperties = {};
    for (let editionAttrIndex in this.feature) {
      let editionAttr = this.feature[editionAttrIndex];
      try {
        if (editionAttr['camp'] && editionAttr['format'] !== 'L' &&  editionAttr['format'] !== 'B') {
          let value_ = document.getElementById(editionAttr['camp'])['value'];
          if (value_ !== null && value_.length > 0) {
            featureProperties[editionAttr['camp']] = value_;
          }
        } else if (editionAttr['format'] === 'L') {
          let selval = this.selectedValue[editionAttr['camp']]
          let valor = editionAttr['valors'].filter(valor => valor['id'] === selval);
          featureProperties[editionAttr['camp']] = valor[0]['id'];
        }else if (editionAttr['format'] === 'B') {
          let value_ = document.getElementById(editionAttr['camp'])['value'];
          if (value_ === 'true' ) {
            value_ = 'Si';
          } else {
            value_ = 'No';
          }
          featureProperties[editionAttr['camp']] = value_;
        }
      }
      catch (e) { }
    }

    localStorage.setItem('temp_edited_values',  JSON.stringify(featureProperties));
    this.modificarPosicio.emit({
      'olFeature': this.olFeature,
      'editionLayer': this.layer,
    });
  }
  public mostrarEnllacPreview(obj) {
    let valor = document.getElementById(obj.camp)['value'];
    obj.enllac = '';
    if (valor.indexOf("http") >= 0)
      obj.enllac = valor;
  }

  protected onImgError(event: Event) {
    const element = event.target as HTMLImageElement;
    element.src = 'assets/img/notFound.png';
    element.width = 64;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/feature-edition-panel/feature-edition-panel.component.ts